module.exports = __webpack_public_path__ + "img/csgoct.4709b72e.png";